import { Space, Tag, Avatar } from "antd";
import { format } from "date-fns";
import NoRecordsFound from "../../../../components/no-records-found";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { baseUrl } from "../../../../services/api";

const BlogTable = ({ data, onEdit, onDelete, onView }) => {
  const headers = [
    "Image",
    "Title",
    "Tags",
    "Status",
    "Author",
    "Updated",
    "Actions",
  ];

  const renderRow = (item) => {
    const visibleTags = item.tags.slice(0, 3);
    const remainingCount = item.tags.length - 3;

    return (
      <tr key={item.id}>
        <td style={{ padding: "0.5rem 1rem", whiteSpace: "nowrap" }}>
          <Avatar src={`${baseUrl}${item.image}`} size={40} style={{ objectFit: "cover" }} />
        </td>
        <td style={{ padding: "0.5rem 1rem", whiteSpace: "nowrap" }}>
          <div className="font-semibold">{item.title}</div>
          <div className="text-muted text-sm">
            {format(new Date(item.createdAt), "MMM dd, yyyy")}
          </div>
        </td>
        <td style={{ padding: "0.5rem 1rem", whiteSpace: "nowrap" }}>
          <Space size={4} wrap>
            {visibleTags.map((tag, index) => (
              <Tag key={index} color="blue" style={{ fontSize: "12px" }}>
                {tag}
              </Tag>
            ))}
            {remainingCount > 0 && (
              <Tag color="default" style={{ fontSize: "12px" }}>
                +{remainingCount}
              </Tag>
            )}
          </Space>
        </td>
        <td style={{ padding: "0.5rem 1rem" }}>
          <Tag color={item.status === "published" ? "green" : "orange"}>
            {item.status.toUpperCase()}
          </Tag>
        </td>
        <td style={{ padding: "0.5rem 1rem" }}>{item.author}</td>
        <td style={{ padding: "0.5rem 1rem" }}>
          {format(new Date(item.updatedAt), "MMM dd, yyyy")}
        </td>
        <td style={{ padding: "0.5rem 1rem", whiteSpace: "nowrap" }}>
          <Space>
            <EyeOutlined
              className="text-blue-600 cursor-pointer"
              onClick={() => onView(item.id)}
            />
            <EditOutlined
              className="text-green-600 cursor-pointer"
              onClick={() => onEdit(item.id)}
            />
            <DeleteOutlined
              className="text-green-600 cursor-pointer"
              onClick={() => {
                if (
                  window.confirm("Are you sure you want to delete this blog?")
                ) {
                  onDelete(item.id);
                }
              }}
            />
          </Space>
        </td>
      </tr>
    );
  };

  return (
    <div
      style={{
        width: "clamp(90%, 90vw, 100%)",
        overflowX: "auto",
        border: "1px solid #f0f0f0",
        borderRadius: 4,
      }}
    >
      <table
        className="table mb-0"
        style={{ width: "100%", fontSize: "clamp(0.8rem, 2vw, 0.9rem)" }}
      >
        <thead className="thead-light">
          <tr>
            {headers.map((header, idx) => (
              <th
                key={idx}
                style={{
                  color: "#333333",
                  padding: "0.5rem 1rem",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map(renderRow)
          ) : (
            <tr>
              <td colSpan={headers.length} className="text-center py-3">
                <NoRecordsFound />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BlogTable;
